<template>
  <div class="quote-product-info">
    <span class="quote-product-name"><strong v-if="category">【{{ category }}】</strong> {{ quote ? quote.productName : fallbackName }}</span>
    <span v-if="residentialSurcharge" class="quote-residential-surcharge"><i class="el-icon-warning-outline" aria-hidden="true" /><span>{{ $t('此渠道会额外收取住宅附加费') }}</span></span>
  </div>
</template>

<script>
export default {
  name: 'QuoteProductName',
  props: {
    quote: { type: Object, default: null },
    category: { type: String, default: '' },
    fallbackName: { type: String, default: '' }
  },
  computed: {
    residentialSurcharge () { return !!this.quote && /^(true|1|yes|y)$/i.test(String(this.quote.productResidential).trim()) }
  }
}
</script>

<style scoped>
.quote-product-info { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 14px; min-width: 0; text-align: left; line-height: 1.6; }
.quote-product-name { flex: 1 1 100px; min-width: 0; overflow-wrap: anywhere; color: #202124; }
.quote-product-name strong { color: #3c4043; font-weight: 600; }
.quote-residential-surcharge { display: inline-flex; align-items: center; gap: 5px; flex: 0 1 auto; max-width: 100%; box-sizing: border-box; padding: 4px 8px; border: 1px solid #eedbb8; border-radius: 6px; background: #fff8eb; color: #946218; font-size: 12px; font-weight: 500; line-height: 18px; }
.quote-residential-surcharge > i { flex: none; color: #b27a20; font-size: 15px; }
.quote-residential-surcharge > span { min-width: 0; overflow-wrap: anywhere; }
</style>
